import React, { useState } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import EAButton from "../../app/components/shared/Buttons/EAButton";
import EAModal from "../../app/components/shared/Modal/EAModal";

interface IProps {
  text: string;
  minLengthText: number;
  title: string;
}

const ReadMore: React.FC<IProps> = ({ text, minLengthText, title }: IProps) => {
  const [readMore, setReadMore] = useState(false);
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <article
        className="readmore-article"
        dangerouslySetInnerHTML={{ __html: text.slice(0, minLengthText) + "..." }}
      ></article>
      <EAButton title={t("przeczytaj_calosc")} onClick={() => setReadMore(!readMore)} variant="outlined" />

      <EAModal
        isOpen={readMore}
        title={title}
        onClose={() => setReadMore(false)}
        cancelButtonLabel={t("przeczytalem")}
        hideAcceptButton
      >
        <p dangerouslySetInnerHTML={{ __html: text }}></p>
      </EAModal>
    </React.Fragment>
  );
};

export default ReadMore;
